import styled from 'styled-components';

const ImageStyle = styled.div`
	--proportion: 50%; /** //! Default size */

	&.imageCont {
		position: relative;
		width: 100%;
		padding-top: var(--proportion);

		img {
			object-fit: cover;
			object-position: center;
			transition: opacity 0.5s ease-out, clip-path var(--trTime) ease-out;
		}
	}
`;
export default ImageStyle;
